import React, {Component} from 'react'

import {
  Avatar,
  // Button,
  CardHeader,
  // Card,
  // CardActions,
} from 'material-ui'

// import {
//   Link
// } from 'react-router-dom'

export default class ApplicantCardHeader extends Component{
  render(){
    const applicant = this.props.applicant;
    return (
      <CardHeader
        avatar={
          <Avatar
            src={applicant.photoURL}
          >
          {applicant.photoURL?null:applicant.displayName?applicant.displayName[0]:applicant.email?applicant.email[0]:null}
        </Avatar>
        }
        title={applicant.displayName}
        subheader={applicant.email || null}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ApplicantCardHeader.js